import { useLocation } from 'react-router-dom';

import { isSellerEntry } from '../pages/flowEntryPages/utils';
import useFlowCountry from './useFlowCountry';
import useIsSellingAvailable from './useIsSellingAvailable';

const useStartAsSeller = () => {
  const country = useFlowCountry();
  const { search } = useLocation();
  return useIsSellingAvailable({ country }) && isSellerEntry(search);
};

export default useStartAsSeller;
